export default __webpack_public_path__ + "static/media/5.6e1a1d53.jpg";